import { format } from 'date-fns';

import type { FamilyEvent, FamilyEventType } from '@/features/guardian/family-events';

type FamilyEventReference = {
  eventId?: string | null;
  bookingId?: string | null;
  playerId?: string | null;
  playerName?: string | null;
  type?: FamilyEventType;
  referenceDate?: Date;
};

const normalize = (value: string) => value.trim().toLocaleLowerCase().replace(/\s+/g, ' ');

/** Resolve mock calendar data from richer or legacy entry-point references. */
export function resolveFamilyEvent(
  events: FamilyEvent[],
  reference: FamilyEventReference,
): FamilyEvent | undefined {
  if (reference.eventId) {
    const event = events.find(item => item.id === reference.eventId);
    if (event) return event;
  }

  if (reference.bookingId) {
    const event = events.find(item => item.bookingId === reference.bookingId);
    if (event) return event;
  }

  let candidates = events;
  if (reference.playerId) {
    candidates = candidates.filter(item => item.playerId === reference.playerId);
  } else if (reference.playerName) {
    const playerName = normalize(reference.playerName);
    candidates = candidates.filter(item => normalize(item.playerName).includes(playerName));
  }

  if (reference.type) {
    candidates = candidates.filter(item => item.type === reference.type);
  }

  if (candidates.length === 0) return undefined;

  const todayKey = format(reference.referenceDate ?? new Date(), 'yyyy-MM-dd');
  return candidates.find(item => item.date >= todayKey) ?? candidates[0];
}
